/**
 * Rewritten version of ProSixPP library.
 */
import $ from 'jquery';

export default class apiPro6pp {
  /**
   * Constructor function.
   */
  constructor() {
    this.apiConfig = {
      url: 'https://api.pro6pp.nl/v1/autocomplete',
      timeout: 10000,
      key: 'aUzLZBHGF8eJhNXk',
    };

    this.isDutchPostcode = apiPro6pp.isDutchPostcode;
    this.isBelgiumPostcode = apiPro6pp.isBelgiumPostcode;
  }

  /**
   * Does a Pro6PP API request.
   *
   * @param {object} params
   *
   * @returns {
   * Promise<jQuery|
   * {
   *   getAllResponseHeaders: (function(): *),
   *   abort: (function(*=): jqXHR),
   *   setRequestHeader: (function(*=, *): jqXHR),
   *   readyState: number,
   *   getResponseHeader: (function(*): *),
   *   overrideMimeType: (function(*): jqXHR),
   *   statusCode: (function(*=): jqXHR)
   * }|
   * (function(...[*]=))|
   * HTMLElement>}
   */
  pro6ppApiCall(params) {
    return $.ajax({
      crossDomain: true,
      dataType: 'jsonp',
      timeout: this.apiConfig.timeout,
      url: this.apiConfig.url,
      data: {
        auth_key: this.apiConfig.key,
        ...params,
      },
    });
  }

  /**
   * Checks if a postcode is Dutch.
   *
   * @param {string} postcode
   *
   * @returns {boolean}
   */
  static isDutchPostcode(postcode) {
    return /^[0-9]{4}[ ]?[A-Za-z]{2}$/.test(postcode);
  }

  /**
   * Check if postcode is Belgian.
   *
   * @param {string} postcode
   *
   * @returns {boolean}
   */
  static isBelgiumPostcode(postcode) {
    return /^[0-9]{4}$/.test(postcode);
  }
}

// Hook into jQuery so we can still use our old functions.
$.fn.pro6pp = () => {
};

/**
 * @deprecated Use class instance instead.
 *
 * @param {string} postcode
 *
 * @returns {boolean}
 */
export function isBelgiumPostcode(postcode) {
  return apiPro6pp.isBelgiumPostcode(postcode);
}

/**
 * @deprecated Use class instance instead.
 *
 * @param {string} postcode
 *
 * @returns {boolean}
 */
export function isDutchPostcode(postcode) {
  return apiPro6pp.isDutchPostcode(postcode);
}
